import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Card, CardContent } from '@/components/ui/Card';
import { useAuth } from '@/hooks/useAuth';

export function Login() {
    const navigate = useNavigate();
    const { login, isLoading, error } = useAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [localError, setLocalError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLocalError('');

        if (!email || !password) {
            setLocalError('Preencha todos os campos');
            return;
        }

        const success = await login({ email, password });

        if (success) {
            navigate('/');
        }
    };

    const displayError = localError || error;

    return (
        <div className="min-h-screen bg-page-bg flex flex-col items-center justify-center p-4">
            {/* Logo */}
            <div className="mb-8 text-center">
                <div className="w-20 h-20 bg-brand-primary rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <svg
                        className="w-12 h-12 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                        />
                    </svg>
                </div>
                <h1 className="text-2xl font-bold text-content-title">
                    Share of Shelf
                </h1>
                <p className="text-content-muted mt-1">
                    Auditoria de Gôndola
                </p>
            </div>

            {/* Card de Login */}
            <Card className="w-full max-w-sm">
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <Input
                            type="email"
                            label="E-mail"
                            placeholder="seu.email@marilan.com.br"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            autoFocus
                        />

                        <Input
                            type="password"
                            label="Senha"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                        />

                        {displayError && (
                            <div className="p-3 bg-status-danger/10 border border-status-danger/20 rounded-lg">
                                <p className="text-sm text-status-danger text-center">
                                    {displayError}
                                </p>
                            </div>
                        )}

                        <Button
                            type="submit"
                            fullWidth
                            size="lg"
                            isLoading={isLoading}
                        >
                            Entrar
                        </Button>
                    </form>

                    {/* Dica para desenvolvimento */}
                    <div className="mt-6 p-3 bg-brand-surface rounded-lg">
                        <p className="text-xs text-content-muted text-center">
                            <strong>Dev:</strong> admin@marilan.com.br / admin123
                        </p>
                    </div>
                </CardContent>
            </Card>

            {/* Versão */}
            <p className="mt-8 text-xs text-content-muted">
                v1.0.0 • Marilan Alimentos
            </p>
        </div>
    );
}

export default Login;
